<ng-container>
  <div class="row">
    <div class="title">
      <i class="{{config.headerConfig!.icon}}"></i>
      <span>{{ config.headerConfig!.title!.label | translate }}</span>
    </div>
    <div *ngIf="config.headerConfig!.actions" class="actions">
      @for (action of config.headerConfig!.actions; track action) {
        <span class="icon {{action.icon!}}" (click)="onClickAction(action.type!, {})"></span>
      }
    </div>
  </div>

  @if (isLoading) {
    <div class="loader">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    <ul>
      @for (item of list; track item) {
        <li [class]="currentChoose == item ? 'selected-clear' : ''">
          <span [title]="item | listItem:entity"
                [style.position]="'relative'"
                [style.display]="'inline-block'"
                [style.color]="item.color"
                [style.background-color]="item.background"
                (click)="onClick(item)"
          >
            {{ item | listItem:entity }}
          </span>

          <ng-container>
            <span
              class="action duplicate"
              (click)="onClickAction(duplicate.type, item)"
            >
              <mat-spinner [diameter]="20" *ngIf="duplicateLoading; else duplicateIcon"></mat-spinner>
              <ng-template #duplicateIcon>
                <i class="{{duplicate.icon}}"></i>
              </ng-template>
            </span>
          </ng-container>

          <ng-container>
            <span class="action deleted"
                  (confirm)="onClickAction(softDeleted.type, item)"
                  [confirmMessage]="softDeleted.confirmMessage"
                  [titleMessage]="softDeleted.titleMessage"
            >
            <mat-spinner [diameter]="20" *ngIf="deleteLoading; else softDeletedIcon"></mat-spinner>
            <ng-template #softDeletedIcon>
              <i class="{{softDeleted.icon}}"></i>
            </ng-template>
          </span>
          </ng-container>
        </li>
      }
    </ul>
  }
</ng-container>
